import { giftService } from "@/lib/api/services/gift";
import { useMutation, useQuery, keepPreviousData } from "@tanstack/react-query";
import { logger } from "@/lib/logger";
import { Gift } from "@/types/gift";

export function useGift(token: any) {
  return useQuery<Gift>({
    queryKey: ["gift"],
    queryFn: async () => {
      if (!token) throw new Error("No token provided");
      try {
        return await giftService.getGift(token);
      } catch (error) {
        logger.error("Gift Query failed", {
          error: error instanceof Error ? error.message : String(error),
        });
        throw error;
      }
    },
    staleTime: 60_000,
    enabled: !!token,
  });
}

export function useRevealMutation() {
  return useMutation({
    mutationKey: ["reveal-gift"],
    mutationFn: (request: { reveal: boolean; token: string }) => giftService.reveal(request),
  });
}

export function useGiftOption() {
  return useQuery({
    queryKey: ["gift", "option"],
    queryFn: async () => {
      try {
        return await giftService.option();
      } catch (error) {
        logger.error("Gift option failed", {
          error: error instanceof Error ? error.message : String(error),
        });
        throw error;
      }
    },
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}

export function useGetGift() {
  return useQuery<any>({
    queryKey: ["gift", "all"],
    queryFn: async () => {
      try {
        return await giftService.getAll();
      } catch (error) {
        logger.error("Gift Query failed", {
          error: error instanceof Error ? error.message : String(error),
        });
        throw error;
      }
    },
    staleTime: 60_000,
  });
}

export function useDownloadGift(token: any) {
  return useQuery<Gift>({
    queryKey: ["gift"],
    queryFn: async () => {
      if (!token) throw new Error("No token provided");
      try {
        return await giftService.download(token);
      } catch (error) {
        logger.error("Download Gift failed", {
          error: error instanceof Error ? error.message : String(error),
        });
        throw error;
      }
    },
    staleTime: 60_000,
    enabled: false,
  });
}
